import React from "react";
import { useTenant } from "../lib/tenant";

/**
 * Tenant-aware logo. Falls back to the Sagewood 25-year asset if branding
 * is not yet loaded (avoids FOUC during initial fetch).
 *
 * Variants:
 *  - "stacked": full lockup
 *  - "mark":    compact square (avatars / sidebar)
 *
 * Tone:
 *  - "dark":  native logo on light surfaces
 *  - "light": inverted via filter for dark hero surfaces
 */
const FALLBACK_STACKED = "/sagewood-25y-light.png";
const FALLBACK_MARK = "/sagewood-25y-mark.png";

export default function Logo({ variant = "stacked", tone = "dark", className = "", style = {} }) {
  const { branding } = useTenant();
  const filter = tone === "light" ? "brightness(0) invert(1)" : undefined;
  const b = branding || {};
  const src = variant === "mark"
    ? (b.logo_mark_url || b.logo_url || FALLBACK_MARK)
    : (b.logo_url || FALLBACK_STACKED);
  return (
    <img
      src={src}
      alt="Logo"
      draggable={false}
      className={className}
      style={{ filter, objectFit: "contain", ...style }}
    />
  );
}
